import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import qs from 'qs';

interface Vendor {
  id: string;
  name: string;
  company: string;
  user: string | null;
}

export interface VendorProduct {
  id: string;
  logo?: SizedImage;
  name: string;
  company: string;
  user: string;
  vendor: Vendor;
}

export interface UseVendorProductsParams extends EndpointParams {
  vendor?: string;
  tag?: string[];
  has_instance?: boolean;
}

interface UseVendorProductsConfig {
  enabled?: boolean;
}

export const useVendorProducts = ({
  params,
  config
}: {
  params: UseVendorProductsParams;
  config?: UseVendorProductsConfig;
}) => {
  return useQuery({
    queryKey: ['/v1/vendor_products', params] as const,
    queryFn: async ({ queryKey: [url, params] }) => {
      const { data } = await axios.get<PaginatedResponse<VendorProduct>>(url, {
        params,
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
      });
      return data;
    },
    ...config
  });
};

export const useVendorProduct = ({ id }: { id: string }) => {
  return useQuery({
    queryKey: [`/v1/vendor_products/${id}`] as const,
    queryFn: async ({ queryKey: [url] }) => {
      const { data } = await axios.get<VendorProduct>(url);

      return data;
    },
    enabled: !!id
  });
};
